import { useState } from "react";
import ImageGallery from "react-image-gallery";
import Modal from "react-bootstrap/Modal";
import "./shopViewModel.css";
import { Row, Col, Tabs, Tab, Card } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import { RatingStar } from "../../constants/jsonConstant";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAsset, formatCurrencyCode } from "../../helpers/helper";
import MessageIcon from "@mui/icons-material/Message";
import moment from "moment";
import CancelIcon from "@mui/icons-material/Cancel";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";

const UserbuyShopViewModel = ({ show, handleClosetwo, shopview }) => {
  const { name } = useSelector((state) => state.user);
  const [value] = useState(5);
  const [valueone] = useState(4);
  const [valuetwo] = useState(3);
  const [valuethree] = useState(2);
  const [valuefour] = useState(1);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const location = useLocation();

  let imagesArray = [];
  if (shopview) {
    const rawImages = shopview.image || shopview.images;
    if (Array.isArray(rawImages)) {
      imagesArray = rawImages;
    } else if (typeof rawImages === "string" && rawImages.trim() !== "") {
      imagesArray = [rawImages];
    }
  }
  imagesArray = imagesArray.filter(
    (img) =>
      img &&
      typeof img === "string" &&
      img.trim() !== "" &&
      img !== "undefined" &&
      img !== "null",
  );

  const ShopModelCarousal = imagesArray.map((image, index) => ({
    id: index + 1,
    original: getAsset(image),
    thumbnail: getAsset(image),
  }));

  const hasImages = ShopModelCarousal.length > 0;

  const handleSendMessage = () => {
    const ownerId = shopview?.userid?._id || shopview?.userid;
    if (!ownerId) return;
    const targetUser = {
      _id: ownerId,
      fullname:
        shopview?.userid?.fullname || shopview?.username || "Shop Owner",
      image:
        shopview?.userid?.imageUrl?.[0] || shopview?.userid?.profilePic || null,
      position: "User",
      businessType: shopview?.businessType || "generalPublic",
    };
    localStorage.setItem("messengerTargetUser", JSON.stringify(targetUser));
    window.dispatchEvent(
      new CustomEvent("open-messenger", { detail: targetUser }),
    );
    handleClosetwo();
  };

  return (
    <>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClosetwo}
      >
        <Modal.Body className=" pt-3  pb-3">
          <div className="d-flex justify-content-between">
            <div>
              <p>
                Posted At :{" "}
                {shopview?.createdAt ? (
                  moment(shopview?.createdAt).format("DD-MM-YYYY")
                ) : (
                  <Skeleton width={80} />
                )}
              </p>
            </div>

            <div>
              <CancelIcon
                className="mt-0 pt-0 mb-4"
                fontSize="large"
                style={{ color: "red", cursor: "pointer" }}
                onClick={handleClosetwo}
              />
            </div>
          </div>
          {!shopview ? (
            <Row>
              <Col lg="6">
                <div style={{ padding: "10px" }}>
                  <Skeleton height={320} style={{ borderRadius: "8px" }} />
                </div>
              </Col>
              <Col lg="6">
                <div className="ps-4 pe-4 pt-4 pb-4">
                  <Skeleton height={35} width="80%" className="mb-3" />
                  <Skeleton count={4} className="mb-3" />
                  <div className="mt-4">
                    <Skeleton height={20} width="30%" className="mb-1" />
                    <Skeleton height={30} width="50%" className="mb-4" />
                  </div>
                  <div>
                    <Skeleton height={20} width="40%" className="mb-2" />
                    <Skeleton height={20} width="60%" className="mb-4" />
                  </div>
                  <Skeleton
                    height={40}
                    width="80%"
                    style={{ borderRadius: "4px" }}
                  />
                </div>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col lg="6">
                <div className="userbuy-gallery-wrapper">
                  {hasImages ? (
                    <ImageGallery
                      showPlayButton={false}
                      showFullscreenButton={false}
                      items={ShopModelCarousal}
                      onImageError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImagePlaceholder;
                      }}
                    />
                  ) : (
                    <div
                      className="d-flex flex-column align-items-center justify-content-center w-100"
                      style={{
                        minHeight: "320px",
                        height: "100%",
                        background: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <img
                        src={noImagePlaceholder}
                        alt="No Image Found"
                        style={{
                          width: "70%",
                          maxHeight: "200px",
                          objectFit: "contain",
                          opacity: 0.7,
                        }}
                      />
                      <p
                        className="text-muted mt-2 mb-0"
                        style={{ fontSize: "13px", fontWeight: 500 }}
                      >
                        No Image Found
                      </p>
                    </div>
                  )}
                </div>
              </Col>
              <Col lg="6">
                <Tabs
                  defaultActiveKey="Item"
                  id="fill-tab-example"
                  className="mb-3"
                  fill
                >
                  <Tab title="Item" eventKey="Item">
                    <div className=" ps-4 pe-4 pt-4 pb-3 bg-vilot View-Model-Shadow h-100 d-flex flex-column justify-content-between" style={{ minHeight: "390px" }}>
                      <div>
                        <h4 className="fw-bold">
                          {shopview?.itemname || shopview?.subCategory}
                        </h4>
                        <div>
                          <p
                            className={`col-12 fw-lighter ${
                              showFullDesc
                                ? "buy-desc-expanded noscroll"
                                : "buy-desc-clamped"
                            }`}
                          >
                            {shopview?.description}
                          </p>
                          {shopview?.description && shopview?.description?.length > 80 && (
                            <button
                              type="button"
                              className="show-more-btn"
                              onClick={() => setShowFullDesc((prev) => !prev)}
                            >
                              {showFullDesc ? "Show less" : "Show more"}
                            </button>
                          )}
                        </div>

                        <div>
                          <p className="mb-0">Price:</p>
                          <h3 className="font-blue">
                            {formatCurrencyCode(shopview?.currency)}&nbsp;
                            {shopview?.price}
                          </h3>
                        </div>
                        <div>
                          <p className="mb-0">Contact us on</p>
                          <p className="mb-0 pt-2 pb-2">
                            {shopview?.userid?.email
                              ? shopview?.userid?.email
                              : name?.email}
                          </p>
                        </div>
                      </div>

                      <div className="pt-3 cursor">
                        {location.pathname === "/wholeseller-userprofile" ||
                        location.pathname === "/manufacturer-userprofile" ||
                        location.pathname === "/rawmaterial-userprofile" ? (
                          ""
                        ) : (
                          <button
                            onClick={handleSendMessage}
                            className=" d-flex align-items-center justify-content-center mb-0 border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 w-75 text-white"
                          >
                            <MessageIcon fontSize="small" className="mt-1" />
                            <span className="ps-2">Send Message</span>
                          </button>
                        )}
                        {location.pathname === "/wholeseller-userprofile" ||
                        location.pathname === "/manufacturer-userprofile" ||
                        location.pathname === "/rawmaterial-userprofile" ? (
                          <button
                            onClick={handleSendMessage}
                            className=" d-flex align-items-center justify-content-center mb-0 border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 w-75 text-white"
                          >
                            <MessageIcon fontSize="small" className="mt-1" />
                            <span className="ps-2">Send Message</span>
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </Tab>
                  {/* <Tab
                    className="shadow-none  bg-light rounded"
                    eventKey="Reviews"
                    title="Reviews"
                  >
                    <Row>
                      <Col lg={6}>
                        <div className="mt-3">
                          <h4 className="mb-4">4.4/5</h4>

                          <Rating
                            className="mb-3"
                            name="read-only"
                            value={value}
                            readOnly
                          />
                          <p>7 Ratings</p>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="mt-3 mb-2">
                          <div className="rating-stars  d-flex ">
                            <Rating name="read-only" value={value} readOnly />
                            <h6>6</h6>
                          </div>
                          <div className="rating-stars  d-flex ">
                            <Rating name="read-only" value={valueone} readOnly />
                            <h6>0</h6>
                          </div>
                          <div className="rating-stars  d-flex ">
                            <Rating name="read-only" value={valuetwo} readOnly />
                            <h6>0</h6>
                          </div>
                          <div className="rating-stars  d-flex ">
                            <Rating
                              name="read-only"
                              value={valuethree}
                              readOnly
                            />
                            <h6>0</h6>
                          </div>
                          <div className="rating-stars  d-flex ">
                            <Rating name="read-only" value={valuefour} readOnly />
                            <h6>1</h6>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <div className="card-scrolll">
                      {RatingStar.map((e) => (
                        <div key={e.imgstarss}>
                          <img src={e.imgstarss} alt="" />
                          <h6 className="pt-1">
                            BY A...
                            <img src={e.Phera2} alt="" /> Verified purchase
                          </h6>

                          <Card style={{ height: "13rem" }}>
                            <Card.Body>
                              <h6 className="phgh">{e.Phera} </h6>
                              <img src={e.image} alt="" className="pe-2" />
                              <img src={e.images} alt="" />
                            </Card.Body>
                          </Card>
                        </div>
                      ))}
                    </div>
                  </Tab> */}
                </Tabs>
              </Col>
            </Row>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserbuyShopViewModel;
